export default __webpack_public_path__ + "static/media/FP-UFO.9fe724ec.png";